import { TEtapa } from '../../ts/types/ObrigacaoEtapa/Etapas/Etapa';

export default function todasEtapasConcluidas(listaEtapas: TEtapa[]): boolean {
	return listaEtapas.every((etapa) => etapa.aprovada && etapa.concluida);
}
